export default __webpack_public_path__ + "static/media/active-folder-open.994a4360.svg";